import { useIntl } from 'react-intl'
import { ProcessUpdate, Status } from '@racepointenergy/swc/scs/types/host'

import { processMessages } from './messages'
import BaseMobileModal from 'components/Modal/BaseMobileModal'
import {
  ProcessInfoCloseButton,
  ProcessInfoMobilePopupContainer,
  ProcessInfoMobileWrapper,
  ProcessInfoNameLabel,
  ProcessInfoRowLabel,
  ProcessesStatusLabel,
  ProcessesTableInfoActionItemRow,
  ProcessesTableInfoItemBodyItem,
  ProcessesTableInfoItemRow,
} from './styles'
import formatBytes from 'app/utils/formatBytes'

interface ProcessInfoMobileProps {
  value?: ProcessUpdate
  onClose: () => void
}

const ProcessInfoMobileComponent = (props: ProcessInfoMobileProps) => {
  const { formatMessage } = useIntl()

  const processInfo = props.value

  return (
    <BaseMobileModal isOpen>
      <ProcessInfoMobilePopupContainer>
        <ProcessesTableInfoItemRow>
          <ProcessInfoNameLabel>
            {processInfo?.ApplicationName}
          </ProcessInfoNameLabel>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoActionItemRow>
          <ProcessesStatusLabel isRunning={!processInfo?.Status}>
            {Status[processInfo?.Status as number]}
          </ProcessesStatusLabel>
        </ProcessesTableInfoActionItemRow>

        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.cpuUsageTitle)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.CpuUsage?.toFixed(2)}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.virtualMemoryTitle)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {formatBytes(processInfo?.VirtualMemorySize)}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.physicalMemoryTitle)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {formatBytes(processInfo?.PhysicalMemorySize)}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.pageFaultsTitle)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.PageFaults}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.processThreadsTitle)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.ThreadCount}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.processMessagesSent)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.MessagesSent}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.processMessagesReceived)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.MessagesReceived}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.processFileDescriptors)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.FileDescriptors}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.processVersion)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.Version}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessesTableInfoItemRow>
          <ProcessInfoRowLabel>
            {formatMessage(processMessages.processBuild)}
          </ProcessInfoRowLabel>
          <ProcessesTableInfoItemBodyItem>
            {processInfo?.BuildNumber}
          </ProcessesTableInfoItemBodyItem>
        </ProcessesTableInfoItemRow>
        <ProcessInfoMobileWrapper>
          <ProcessInfoCloseButton onClick={props.onClose} variant="primary">
            {formatMessage(processMessages.closeButton)}
          </ProcessInfoCloseButton>
        </ProcessInfoMobileWrapper>
      </ProcessInfoMobilePopupContainer>
    </BaseMobileModal>
  )
}

export default ProcessInfoMobileComponent
